export enum Pages {
	Home = '/orders',
	Orders = '/orders',
	Products = '/products',
	Sales = '/sales',
	AccountAndSettings = '/settings',
	Forum = '/forum',
	SIgnIn = '/sign-in',
}
